import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

import type { ProfileDocumentRouteModel } from '../../route';

export default class ProfileDocumentUploadIndexRoute extends Route {
  @service declare router: RouterService;

  redirect(): void {
    const { userDocumentTemplate } = <ProfileDocumentRouteModel>this.modelFor('profile.document');

    const sortedUserDocumentTemplateAttachments =
      userDocumentTemplate!.userDocumentTemplateAttachments.content.toSorted((a, b) => a.position - b.position);

    void this.router.replaceWith(
      'profile.document.upload.attachment',
      userDocumentTemplate!.identifier,
      sortedUserDocumentTemplateAttachments[0]!.identifier,
    );
  }
}
